/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
import { areNonessentialCookiesDisabled } from "./CookieConsentUtils";
var webTrackingGlobalName = "MSCI";
var guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export var getCidUserLocalId = function () {
    try {
        if (areNonessentialCookiesDisabled()) {
            return undefined;
        }
        var webTracking = typeof window !== "undefined" ? window[webTrackingGlobalName] : undefined;
        if (typeof (webTracking === null || webTracking === void 0 ? void 0 : webTracking.getLocalId) !== "function") {
            return undefined;
        }
        var cidUserLocalId = webTracking.getLocalId();
        if (typeof cidUserLocalId !== "string" || !guidPattern.test(cidUserLocalId)) {
            return undefined;
        }
        return cidUserLocalId;
    }
    catch (_a) {
        return undefined;
    }
};
